import { BookingSteps, UserProfile } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { Image, StyleSheet, Text, View } from 'react-native';
import FastImage from 'react-native-fast-image';
import { connect } from 'react-redux';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { Arrow } from '../../ui';
import { createBookingServiceClient } from '../../utils/apiClientFactory'
import { defaultScale } from '../../utils/scaling';
import {
  closeFeatureDemoBookingScreen,
  enableMirrorPermissionsPressed,
  setupMirrorLaterPressed,
} from '../actions';
import { HeaderWithCloseButton } from '../components/HeaderWithCloseButton';

interface IProps {
  t: (key: string, options?: any) => string;
  enableMirrorPermissions: () => void;
  userProfile: UserProfile;
  setupMirrorLater: () => void;
  closeModal: () => void;
  closePressed: () => void;
}

const SetupMirrorStepComponent: FunctionComponent<IProps> = ({
                                                               t,
                                                               enableMirrorPermissions,
                                                               setupMirrorLater,
                                                               closeModal,
                                                               closePressed,
                                                             }) => {

  const close = () => {
    closePressed();
    closeModal();
  };

  return (
    <View style={styles.container}>
      <HeaderWithCloseButton onClose={close} />
      <View style={styles.imageContainer}>
        <FastImage
          style={styles.image}
          resizeMode={FastImage.resizeMode.contain}
          source={Image.resolveAssetSource(require('../../assets/images/workout-screen-mirror-open.png'))}
        />
        <View style={styles.arrowContainer}>
          <View style={styles.youArrow}>
            <Arrow label={t('you')} />
          </View>
          <View style={styles.instructorArrow}>
            <Arrow label={t('instructor')} />
          </View>
        </View>
      </View>
      <View style={styles.textContainer}>
        <Text style={styles.heading}>{t('exerciseMirrorHeading')}</Text>
        <Text style={styles.body}>{t('VideoMirrorAllows')}</Text>
        <Text style={styles.privacyText}>{t('VideoMirrorPrivacy')}</Text>
      </View>
      <View>
        <Button
          fontColor={Theme.PRIMARY}
          size={ButtonSize.MEDIUM}
          containerStyle={{ marginBottom: defaultScale(15) }}
          buttonType={ButtonTypes.TRANSPARENT}
          title={t('bookings:dontEnable')}
          onPress={setupMirrorLater}
        />
        <Button
          fontColor={Theme.WHITE}
          size={ButtonSize.MEDIUM}
          title={t('bookings:enable')}
          onPress={enableMirrorPermissions}
        />
      </View>
    </View>
  );
};

const mapDispatchToProps = (dispatch, ownProps: IProps): Partial<IProps> => {
  return {
    enableMirrorPermissions: () => dispatch(enableMirrorPermissionsPressed(ownProps.userProfile)),
    setupMirrorLater: () => dispatch(setupMirrorLaterPressed(ownProps.userProfile)),
    closePressed: () => dispatch(closeFeatureDemoBookingScreen(createBookingServiceClient(), BookingSteps.SetupMirror)),
  };
};

export const SetupMirrorStep = connect(null, mapDispatchToProps)(
  translate(['homeWorkouts'], { wait: true })(SetupMirrorStepComponent));

SetupMirrorStep.getTitle = () => <></>;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  imageContainer: {
    flex: 1,
    justifyContent: 'center',
    alignSelf: 'center',
    maxWidth: 700,
    paddingHorizontal: defaultScale(10),
  },
  image: {
    width: '100%',
    aspectRatio: 1.8,
  },
  textContainer: {
    flex: 0.8,
    justifyContent: 'center',
    paddingHorizontal: defaultScale(10),
  },
  heading: {
    ...Theme.textStyle.heading,
    textAlign: 'center',
    marginVertical: defaultScale(10),
  },
  body: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
    marginVertical: defaultScale(10),
  },
  privacyText: {
   ...Theme.textStyle.mediumItalic,
    textAlign: 'center',
    marginVertical: defaultScale(10),
  },
  youArrow: {
    flex: 0.75,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  instructorArrow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    paddingRight: defaultScale(30),
  },
  arrowContainer: {
    flexDirection: 'row',
  },
});
